

// Calendar.js
import { useEffect, useState } from 'react';
import './Calendar.css';
import { Typography, Grid, IconButton, Button, Container, Box } from "@mui/material";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import Mes from '../../../utils/mes';
import api from '../../../services/api';
import { useNavigate } from "react-router-dom";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { makeStyles } from "@material-ui/core";
import LoadingShort from '../../../load/loadingShort';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import LoadingSkeleton from '../../../load/loadingSkeleton';

const useStyles = makeStyles((theme) => ({
    hover: { '&:hover': { backgroundColor: '#f0f0f0' }, cursor: 'pointer' }
}))

const Calendar = () => {
    const classes = useStyles()
    const [selectedDate, setSelectedDate] = useState(null);
    const navigate = useNavigate()
    const monthNames = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
    const dayNames = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

    const [agendas, setAgendas] = useState([])
    const [isMarked, setIsMarked] = useState([])
    const [loadAgenda, setLoadAgenda] = useState(false)
    const [horarios, setHorarios] = useState([])

    // Obter a data atual
    const [currentDate, setCurrentDate] = useState(new Date());

    // Obter o ano atual
    const currentYear = currentDate.getFullYear();

    // Obter o mês atual e somar 2 para o próximo mês
    let targetMonth = currentDate.getMonth() + 2;  // Meses começam do 0 (Janeiro = 0, Fevereiro = 1, etc.)
    let targetYear = currentYear;

    // Verificar se o mês ultrapassou dezembro (mes 11), e ajustar o ano e mês
    // if (targetMonth > 11) {
    if (targetMonth > 12) {
        targetMonth = targetMonth - 12;  // Voltar para o começo do ano
        targetYear++;  // Incrementar o ano
    }

    useEffect(() => {
        setLoadAgenda(true)

        // API PARA BUSCAR DATA ACTUAL NO SERVIDOR PARA ENVIAR NA REQUISICAO DAS AGENDAS DISPONIVEIS APENAS ATE A DATA DE HOJE.
        api.get(`/get-date`)
            .then(response => {
                // console.log(response)
                api.get(`/agendas?status=Disponível&ano=${targetYear}&mes=${targetMonth}&perPage=200&dataDisponivel=${response.data.date}`)
                    .then(response => {
                        // console.log(response)
                        setAgendas(response.data.agendas);
                        setIsMarked(response.data.agendas);
                        setLoadAgenda(false)
                    }).catch(error => 'console.log(error)')

            }).catch(error => 'console.log(error)')

    }, [currentDate, horarios, targetYear, targetMonth])

    const getHorarios = (day) => {
        if (isMarked.find((e) => e.dia === day) && new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, day) >= new Date())
            setHorarios(agendas.filter(agenda => agenda.dia === day))
        // console.log(horarios)
    };


    // NOVA LOGICA PARA RENDERIZAR O CALENDARIO CORRETAMENTE
    const renderCalendar = () => {

        const baseDate = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth() + 1, 
            1
        );

        const year = baseDate.getFullYear();
        const month = baseDate.getMonth(); 


        const lastDay = new Date(year, month + 1, 0).getDate();
        const firstDayIndex = new Date(year, month, 1).getDay();

        const days = [];
        for (let i = 1; i <= lastDay; i++) {
            days.push({ dia: i, tipo: '' });
        }

        const calendarDays = [];

        for (let i = 0; i < firstDayIndex; i++) {
            calendarDays.push(
                <div key={`empty-${i}`} className="empty-day"></div>
            );
        }

        days.forEach((dayObj) => {
            const day = dayObj.dia;

            const isDisabled =
                new Date(year, month, day) < new Date();

            const isMarkedVerify = isMarked.find(e => e.dia === day);

            calendarDays.push(
                <div
                    key={day}
                    style={selectedDate === day ? { border: '2px solid red', transition: '.5s', transform: 'scale(1.2)' } : null}
                    className={
                        `day ${isDisabled ? 'disabled' : ''}
                ${loadAgenda ? 'disabled' : ''}
                ${!isMarkedVerify && 'disabled'}
                 ${isMarkedVerify?.tipo === 'Renovação' && 'renovacao'}
                 ${isMarkedVerify?.tipo === 'Licenciamento' && 'licenciamento'}
                 `}
                    onClick={() => { handleDayClick(day); getHorarios(day) }}
                >
                    {day}
                </div>
            );
        });

        return calendarDays;
    };

    const handleDayClick = (day) => {
        if (isMarked.find((e) => e.dia === day) && new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, day) >= new Date()) {
            setSelectedDate(day);
        } else {
            alert('Sem agenda disponivel para dia ' + day);
        }
    };


    // PEGAR INFORMACOES SOBRE O SERVICO DE LICENCIAMENTO
    const [sitInfos, setSiteInfos] = useState('')
    useEffect(() => {
        api.get(`/site-infos?menu=INFORMAÇŌES&opcao=Inf. para serviço de Licenciamento de Entidades`)
            .then(res => {
                // console.log(res)
                setSiteInfos(res.data.siteInfos[0]);
            })
            .catch(() => {
            }).finally(() => {
            });
    }, [])

    return (
        <Box sx={{ backgroundColor: 'rgba(0, 0, 0, 0.03)', padding: '3rem', borderRadius: '4px' }}>
            <Container>
                <Grid container >
                    <Grid item md position={'relative'} sx={{ marginRight: { xs: 'none', md: 8 } }} >

                        {sitInfos ?
                            <>
                                <Typography align="center" variant="subtitlte1" style={{ fontSize: 20, fontWeight: 'bold' }}>
                                    {sitInfos?.titulo}
                                </Typography>
                                <br />

                                <div style={{ marginTop: 20, lineHeight: 1.5, textAlign: 'justify' }} dangerouslySetInnerHTML={{ __html: sitInfos?.conteudo }} />
                                <br />
                                {sitInfos?.anexo &&
                                    <Button size='small' sx={{ position: { xs: 'none', md: 'absolute' }, background: '#85287e', color: '#fff', bottom: 10 }} onClick={() => window.open(sitInfos?.anexo, "_blank", "noopener,noreferrer")}>
                                        Baixar Manual
                                        <img src='/img/icones/downloadicon.svg' alt="downloadicon" />
                                    </Button>
                                }
                            </>
                            :
                            <LoadingSkeleton />
                        }
                    </Grid>

                    <Grid md item overflow={'scroll'}>
                        <Typography align="center" variant="h1" style={{ fontSize: 25, fontWeight: 'bold' }}>
                            MARCAÇÃO DE AGENDA
                        </Typography>


                        <br />
                        {/* className={`${!selectedDate && 'calendarClose'}`} */}
                        <div className={`calendar `} style={{ position: 'relative', overflow: 'scroll' }}>
                            {/* <div  style={{ position: 'absolute', width: '50%', height: '50%' ,background:'#000'}}> */}

                            <div className="header">
                                <IconButton onClick={() => { setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1)); setSelectedDate(null) }}>
                                    <NavigateBeforeIcon color='warning' />
                                </IconButton>

                                {/* <h2>{`${monthNames[currentDate.getMonth() + 1]} ${currentDate.getFullYear()}`}</h2> */}
                                <h2>{`${monthNames[(currentDate.getMonth() + 1) % 12]} ${currentDate.getFullYear() + (currentDate.getMonth() === 11 ? 1 : 0)}`}</h2>

                                <IconButton onClick={() => { setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1)); setSelectedDate(null) }}>
                                    <NavigateNextIcon color='warning' />
                                </IconButton>
                            </div>

                            <div className="weekdays">
                                {dayNames.map((day, index) => (
                                    <div key={day}
                                        className={
                                            `weekday 
                         ${index === 1 && 'licenciamento'}
                        ${index === 3 && 'licenciamento'}
                        ${index === 4 && 'licenciamento'}
                            `}>
                                        <span translate="no">{day}</span>
                                    </div>
                                ))}
                            </div>

                            <div className="days">
                                {/* Renderização dos dias do calendário */}
                                {loadAgenda &&
                                    <div style={{ position: 'absolute', top: '50%', left: '50%' }}>
                                        <LoadingShort />
                                    </div>
                                }

                                {/* {(agendas.length === 0 &&  new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, currentDate.getDay()) < new Date())&& */}
                                {(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, currentDate.getDate()) < new Date()) && (
                                    <div style={{ position: 'absolute', width: '100%', height: '100%', background: '#85287dae' }} >
                                        <h1 align='center' style={{ marginTop: '8rem', color: '#fff' }}>
                                            AGENDAMENTO COMPLETO
                                            <br />
                                            <CheckCircleOutlineIcon style={{ fontSize: 50 }} />
                                        </h1>
                                    </div>
                                )}


                                {renderCalendar()}

                            </div>

                            <div className="tags">
                                {/* <div><div className="tag-color1" />Renovação   </div> */}
                                <div>
                                    <div>
                                        <div className="tag-color2" />Licenciamento
                                    </div>
                                </div>
                            </div>

                            {selectedDate !== null && (
                                <div className={`time-table ${selectedDate !== null ? 'show' : ''}`}>

                                    {/* Tabela de horários */}
                                    <h3>Horários disponíveis para {selectedDate} de <Mes mes={targetMonth} /></h3>
                                    {/* INPUT PARA DAR FOCO NO COMPONENTE ASSIM QUE FOR EXIBIDO */}
                                    <input autoFocus type="text" style={{ opacity: 0, height: 1 }} />

                                    <TableContainer >
                                        <Table id="myTable" size="small" stickyHeader aria-label="sticky table">
                                            <TableHead >
                                                <TableRow>
                                                    <TableCell ><Typography noWrap> <strong>Horário</strong></Typography></TableCell>
                                                    <TableCell ><Typography noWrap> <strong>Tipo de agenda</strong></Typography></TableCell>
                                                    <TableCell ><Typography noWrap> <strong>Estado</strong></Typography></TableCell>
                                                </TableRow>
                                            </TableHead>

                                            <TableBody>
                                                {horarios.map((horario) => (
                                                    <TableRow key={horario?._id} className={classes.hover} onClick={() => navigate(`/licenciamento/${horario._id}`)}>

                                                        <TableCell >
                                                            {horario?.hora < 10 ? `0${horario?.hora}` : horario?.hora}:{horario?.minuto < 10 ? `0${horario?.minuto}` : horario?.minuto}</TableCell>
                                                        <TableCell >{horario.tipo}</TableCell>
                                                        <TableCell >{horario.status}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                            )}

                        </div>
                    </Grid>
                </Grid>
            </Container>
        </Box>

    );
};

export default Calendar;
